import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { NotificationCallbacks } from 'api/notifications';
import { ProjectStatusUpdatePublished } from 'api/notifications/meta';
import { StatusUpdateStatuses } from 'api/status-updates';
import { getStatusData } from 'components/organisms/projects/project-list/constants';
import { getProjectStatusUpdatesDetailUrl } from 'utils/urls';
import { InlineLink, ReadableTag, Value } from '../basics';
import { Causer } from './causer';

const color = (status: string) =>
  getStatusData(StatusUpdateStatuses, status)?.color ?? 'gray';

export const ProjectStatusUpdatePublishedView: FC<{
  meta: ProjectStatusUpdatePublished;
  projectId: number;
  callbacks?: NotificationCallbacks;
}> = ({ meta: { by, id, status, title }, projectId, callbacks }) => {
  const { push } = useHistory();
  const open = useCallback(() => {
    if (callbacks?.onStatusUpdateClick) {
      callbacks.onStatusUpdateClick?.(projectId, id);

      return;
    }
    push(getProjectStatusUpdatesDetailUrl(projectId, id));
  }, [callbacks, push, projectId, id]);

  return (
    <FormattedMessage
      id="notifications.messages.project_status_update_published"
      values={{
        causer: <Causer user={by} />,
        status: (
          <Value data-test-id="message.value">
            <ReadableTag color={color(status.value)}>
              {status.value}
            </ReadableTag>
          </Value>
        ),
        title: <InlineLink title={title} open={open} />,
      }}
    />
  );
};
